var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDashboards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Analytics"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 290",
    cx: 86,
    cy: 86,
    r: 86,
    fill: "#F2FBFD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4170",
    x: 67.8123,
    y: 54,
    width: 57,
    height: 63,
    rx: 4,
    transform: "rotate(7.12326 67.8123 54)",
    fill: "#CAF0F8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4170_2",
    x: 58.5,
    y: 54.5,
    width: 56,
    height: 62,
    rx: 3.5,
    fill: "white",
    stroke: "#ADE8F4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4171",
    x: 72,
    y: 91.4285,
    width: 6,
    height: 14,
    fill: "#ADE8F4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4171_2",
    x: 83,
    y: 85.4285,
    width: 6,
    height: 20,
    fill: "#ADE8F4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4171_3",
    x: 94,
    y: 79.4285,
    width: 6,
    height: 26,
    fill: "#ADE8F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0608 67.0299L94.1285 65.857L94.8713 64L100.721 66.3397L98.9577 72.2158L97.042 71.6411L97.877 68.8578L86.14 74.7263L79.6487 82.7157L71.9705 86.8107L71.0293 85.046L78.3511 81.141L84.8598 73.1304L97.0608 67.0299Z",
    fill: "#0096C7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDashboards);
export default __webpack_public_path__ + "static/media/NoDashboards.6513a4f38dd25af3f214e80576e7cf34.svg";
export { ForwardRef as ReactComponent };